<header>
  <app-header></app-header>
</header>
<app-loading-indicator *ngIf="load"></app-loading-indicator>
<router-outlet></router-outlet>
<footer>
  <app-footer></app-footer>
</footer>
